<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">个人</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">信息</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">处理</span>
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">授权书</span>
          </p>
          <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
            <span style="font-family:宋体; font-size:22pt; font-weight:bold">&nbsp;</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">关注字体加黑、加粗表述</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">），关注您对本行的授权内容</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">以及您的权利、义务和责任</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如您对本授权书的内容有任何疑问</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">意见或建议</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，您可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行咨询，或者通过贷款人和/或贷款人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">合作机构的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上服务平台、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">线上客服</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等进行咨询了解</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">查询、获知您行使个人信息主体相关权利的方式和程序。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">一旦您通过点击或其他方式确认本授权书，即意味着您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">已知晓、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">理解本授权书中的全部内容（包括对有关权利义务和/或责任限制、免除条款的法律含义有充分的理解），同意按照本授权书条款处理您的相关信息。如涉及合作金融机构咨询与投诉事项，您也可以通过上述方式联系亿联银行协助转办。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">吉林</span>
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">亿联银行</span>
            <span style="font-family:宋体; font-size:11pt; text-decoration:underline">股份有限公司</span>
            <span style="font-family:宋体; font-size:11pt">（以下简称：被授权人）:</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">本人</span><span style="font-family:宋体; font-size:11pt">（</span>
            <span style="font-family:宋体; font-size:11pt">即授权人</span><span style="font-family:宋体; font-size:11pt">）</span>
            <span style="font-family:宋体; font-size:11pt">已仔细阅读本授权书的全部内容，</span>
            <span style="font-family:宋体; font-size:11pt">充分理解并同意，本贷款服务是被授权人为本人提供的个人贷款服务，为客观、准确地评估本人的信用等级和授信额度，并为本人提供优质的服务，就使用本人的相关必要信息，本人同意并授权如下：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">一、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">处理（包括但不限于</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">收集、存储、使用</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">加工、传输、提供、公开、删除等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如下个人信息：</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">1、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">个人基本信息：包括姓名、性别、国籍、职业、工作单位、联系地址、联系方式、个人电子邮件；</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">2、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">个人身份信息：包括</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证、居住证</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">证件</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">类型</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">及号码、有效</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">期限</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">公安身份核验信息、学历学籍信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">3</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人财产信息：银行账户信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">（</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">含开户人名称和开户行名称、账号</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">）</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、鉴别信息（口令）、资产信息、房产信息、收入状况、信贷记录、征信信息、交易和消费记录、流水记录、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">生产经营、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">税务信息、社保账户信息及公积金信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">4</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人生物识别信息：指纹、面部识别特征。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5、网络身份标识信息：个人信息主体账号、IP地址、个人数字证书。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">6</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、个人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">常用设备信息等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">其他信息：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">运营商信息、手机号码归属、工商信息、司法信息、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">精准定位信息、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">唯一</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">设备识别码、设备</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">MAC</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">地址、社交平台账号信息、常用设备信息、浏览器环境信息、音视频双录信息（包含电核录音、视频连线、视频核验等）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">7、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">基于前述信息对个人信用状况形成的分析、评价类信息</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="margin:0pt 0pt 10pt; text-indent:22pt">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">8、其他合法存有本人信息的第三方所存的能够评估和反映本人信用和风险状况的信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">二、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于提供贷款服务的需求，将个人信息用于贷款服务相关的身份识别、资质审查、风险评估、</span>
            <span style="font-family:宋体; font-size:11pt">风险管理、</span>
            <span style="font-family:宋体; font-size:11pt">贷前调查、审查审批、合同签署、放款审核、额度管理、风险监测、担保办理、客户服务、权益服务、贷后管理（含催收、逾期资产处置、诉讼仲裁）、贷后服务、资产转让、债权转让、客户服务（含投诉处理）、数据研究分析等用途</span>
            <span style="font-family:宋体; font-size:11pt">，</span>
            <span style="font-family:宋体; font-size:11pt">以及在被授权人监管机构要求的信用监控、授权人申请征信异议处理、依法或依有权部门要求的其他工作，或其他经本人同意的合法用途</span>
            <span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">1、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的收集、存储、使用、加工本人在使用信贷服务过程中主动提供或因此产生的个人信息。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">2、</span><span style="font-family:宋体; font-size:11pt">本人</span>
            <span style="font-family:宋体; font-size:11pt">同意并授权</span><span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于处理目的向金融信用信息基础数据库、</span>
            <span style="font-family:宋体; font-size:11pt">国务院征信业监督管理部门批准设立的征信机构【包括但不限于</span>
            <span style="font-family:宋体; font-size:11pt">百行征信有限公司、朴道征信有限公司</span>
            <span style="font-family:宋体; font-size:11pt">】</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">政府部门或由政府部门授权的其他第三方机构以及其他被授权人合作机构【包括但不限于全国公民身份证号码查询服务中心（公安部公民身份信息数据库）、教育部学生服务与素质发展中心（即中国高等教育学生信息网）、中国银联股份有限公司、百融云创科技股份有限公司、北京中盾安信科技发展有限公司、中国司法大数据研究院有限公司、金保信社保卡科技有限公司、中国联合网络通讯有限公司及其分公司或全资子公司、中国移动通信集团有限公司及其分公司或其他代理通讯运营商业务的机构】、</span>
            <span style="font-family:宋体; font-size:11pt">社会保障管理机构、住房公积金管理机构、银行卡清算机构、合法存有本人信息的第三方以及</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">行内系统，收集、存储个人信息</span>
            <span style="font-family:宋体; font-size:11pt">及本人信贷信息、信用报告等</span>
            <span style="font-family:宋体; font-size:11pt">，并对其进行必要的使用、加工。</span>
            <span style="font-family:宋体; font-size:11pt">并同意授权，被授权人将上述个人信息、个人信贷信息和信用报告以及其他相关信息中的必要信息提供、传输至上述所列合法机构，该合法机构使用该信息向被授权人提供相关信息查询、下载等服务，将查询、核实结果提供、传输至被授权人，及履行法定职责或法定义务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">3</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意并授权百行征信有限公司基于开展征信业务目的，有权向被授权人和合法留存本人信息的机构（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、银联、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）查询、核实、收集如下信息：本人的基本信息、借贷信息、其他相关信息。本人同意并授权百行征信有限公司有权对从合法留存本人信息的机构采集的本人信息进行存储、整理、保存、加工，并将采集的信息或信息处理结果提供给经本人授权的第三方使用。因本条产生的异议，包括需查询、复制、补充、提供、删除个人信息或撤回授权的，可通过以下联系方式联系百行征信有限公司。百行征信有限公司联系方式为：400-007-1100，邮箱bhcs@baihangcredit.com,登陆“百行征信”app或前往百行征信客服中心。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">4</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt">本人同意朴道征信有限公司（联系方式：service@pudaocredit.cn
              ）基于为本人与被授权人之间的金融活动提供信用服务，可向被授权人和有关部门、单位（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、银联、通联、易宝、宝付、旷视、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）查询、核实、采集、整理、保存、加工本人能够用于判断个人信用状况的各类信息（包括但不限于个人的身份、地址、交通、通信、债务、财产、支付、消费、生产经营、履行法定义务等信息，以及基于前述信息对个人信用状况形成的分析、评价类信息），包括可能对本人产生负面影响的不良信息，并可将上述信息在本授权书所列的用途范围内向被授权人提供。上述信息的保存期限为法律法规要求的最短时间，其中个人不良信息的保存期限为自不良行为或事件终止之日起5年。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">5</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：被授权人</span>
            <span style="font-family:宋体; font-size:11pt">基于风险管理目的，在本人通过电脑、手机等电子设备使用</span>
            <span style="font-family:宋体; font-size:11pt">贷款</span>
            <span style="font-family:宋体; font-size:11pt">服务时，收集、存储该设备位置信息，并对其进行必要的使用、加工。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">6</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">为了防范风险等合法目的，向合法留存本人信息的其他方（如被授权人的合作伙伴等，具体合作伙伴范围等以被授权人网站/APP或其他公开渠道公布的名单为准）收集或核验与授权业务相关的必要信息；如本人出现违约或可能危及</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span><span style="font-family:宋体; font-size:11pt">债权的情形时，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">无法通过本人预留联系方式取得有效联系的，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">有权向金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司、行政机关、司法机关、通信运营商、本人的单位和联系人及合法存有本人信息的第三方收集、存储其他有效联系方式，并对其进行必要的使用、加工。本人承诺：向</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">提供的第三方联系人信息，本人已充分告知第三方并取得其同意。因本人承诺不实或者第三方因本人提供其信息而向</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span><span style="font-family:宋体; font-size:11pt">索赔，给</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">造成损失或其他不利后果的，由本人承担赔偿责任。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">三</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人可以向</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">依法设立的征信机构或信用服务机构提供本人的个人基础信息（包括但不限于本人的基本信息、借贷信息、履约风险信息、担保信息、商业保险信息、不动产信息、纳税信息、设备信息、实名验证信息、人脸识别结果、收入信息、消费信息、车辆信息）和信贷业务交易等相关信用信息（包括但不限于本人因未及时履行合同义务产生的不良信息）。本人知悉，被授权人向征信机构提供本人相关信息为其履行《征信业管理条例》第二十九条（即“向金融信用信息基础数据库提供信贷信息”）规定的义务所必须。且本人知悉，信用记录、信用报告或信用评分是国家机关、其他个人和机构对信用进行依法查询和/或提供服务或进行限制的参考依据，本人已经理解并知悉提供该等信息可能会对本人产生的影响。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">四</span>
            <span style="font-family:宋体; font-size:11pt">、本人同意并授权：被授权人可收集、存储、使用、分析本人在注册、使用服务时，在被授权人的相关历史信息、支付数据信息和本人注册、使用被授权人软件产品产生的相关必要信息等，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括但不限于所提供的姓名，身份证信息、影像，银行卡信息、影像，身份验证过程中产生的图像视频数据等相关身份信息</span>
            <span style="font-family:宋体; font-size:11pt">以及使用本服务的相关操作及行为信息（例如，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">操作记录、设备型号和配置、操作系统版本、设备配置、唯一设备标识符等软硬件特征信息，IP地址、GPS位置和基站等传感器信息等位置信息，及浏览器的类型、电信运营商、使用的语言、访问日期和时间以及访问时长等对服务的详细使用情况，作为有关网络日志保存</span>
            <span style="font-family:宋体; font-size:11pt">）。本服务通过使用这些信息识别本人的身份，以便遵守国家相关法律法规的规定，为本人提供贷款服务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">提示：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">上述信息涉及个人敏感信息，如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">拒绝提供上述信息，被授权人将无法为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供本服务，但不影响其为</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">您</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供其他服务。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">五</span>
            <span style="font-family:宋体; font-size:11pt">、本人知悉并同意在后续的信贷业务相关服务（如额度调整、还款方式变更、客户资料变更等）办理流程中补充及调整相关个人信息，如个人身份信息、联系方式、学历学籍信息、居住信息、职业信息、账户信息、交易信息等必要信息时，无需重新进行授权。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">六</span><span style="font-family:宋体; font-size:11pt">、本人同意并授权</span>
            <span style="font-family:宋体; font-size:11pt">：（</span><span style="font-family:宋体; font-size:11pt">1</span>
            <span style="font-family:宋体; font-size:11pt">）</span><span style="font-family:宋体; font-size:11pt">如</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">将本授权书涉及的业务所对应的债权及担保权利转让给第三方时，为订立、履行本人作为一方当事人的合同所必需，</span>
            <span style="font-family:宋体; font-size:11pt">被授权人</span>
            <span style="font-family:宋体; font-size:11pt">有权依法合规在必要范围内向潜在受让的金融机构提供本授权书涉及的业务的相关资料及本人信息，而无须另行征得本人同意。</span>
            <span style="font-family:宋体; font-size:11pt">（</span><span style="font-family:宋体; font-size:11pt">2</span>
            <span style="font-family:宋体; font-size:11pt">）</span>
            <span style="font-family:宋体; font-size:11pt">被授权人转让其所拥有的针对本人的债权时，依照法律法规的规定，向债权受让方提供个人基本信息、个人联系方式、账户信息等必要个人信息，用于业务处理的必要需求</span>
            <span style="font-family:宋体; font-size:11pt">，而无须另行征得本人同意</span><span style="font-family:宋体; font-size:11pt">。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">七</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护被授权人的合法权益，在本人逾期还款或者出现本人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">违反</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">与被授权人签署的合同、协议、承诺或其他法律文件项下的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">约定</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">时，被授权人可将本人的联系方式、联系地址及本人违约信息等信息公开，并根据欠款催收、债权转让、金融外包等需要将</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">个人基本信息、个人联系方式、账户信息等必要个人信息</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">提供给被授权人委托的催收机构、资产管理公司、外包公司等第三方使用，本人知晓并同意具体第三方范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">准入的有资质的</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">名单为准。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">八</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">为便于向本人提供更加优质的服务和产品，本人授权被授权人可以将前述信息分享给与本人在被授权人办理业务相关的被授权人合作伙伴，本人知晓并同意具体合作伙伴范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人认可的名单为准。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">九</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意并自愿授权：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">将收集的个人信息进行存储，保存期限为本授权书生效之日起至本人与</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">业务关系终结之日另加</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">年。如法律、行政法规、政府规章、监管规范（包括但不限于反洗钱）对客户个人信息资料有更长保存期限要求的，遵守其规定。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">超过存储期限，被授权人会将您的个人信息删除或匿名化处理。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.85pt; widows:0">
            <span style="font-family:宋体; font-size:11pt">十</span><span style="font-family:宋体; font-size:11pt">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本授权书是本人向被授权人做出的单方承诺，且效力具有独立性，不因《借款额度合同》、《借款合同》</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">等</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">（以实际名称为准）的任何条款无效而失效。</span>
            <span style="font-family:宋体; font-size:11pt">本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务终结之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">十一</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人信贷业务未获批准，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止，同时同意</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">删除本人个人信息资料，无须退回本人。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十二、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十三、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已知悉</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">公布的相关隐私保密条款,了解</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">会按照国家信息系统安全保护相关要求，进行安全管理，维护本人的个人信息安全，并知悉本人在个人信息处理活动中还可向</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">行使法律所赋予本人对个人信息的知情权、决定权、查阅权、复制权、更正及补充权、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">撤回权、删除请求权、拒绝权、保护权、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">解释</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">请求</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">权等。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如本人拟按照《个人信息保护法》的规定行使上述权限，或存在其他有关争议、投诉或问题，本人可致电</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold; text-decoration:underline">被授权人客户服务电话95396</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">咨询或处理；撤回授权后，不会影响被授权人基于本人同意已进行的信息处理效力；如涉及提供个人信息查询、处理服务的其他主体，本人可按照其他联系方式或有关信息联系相应主体处理。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">符合《个人信息保护法》第十三条第2-7款等法律规定的情形除外。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">四</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">如</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书修改，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">将提前公告或通知本人。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">有权根据实际业务情况选择以下一种或多种方式予以通知，具体可供选择的通知方式包括但不限于网站公告、电子邮件告知、短信通知、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">APP或者微信小程序/公众号公告、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">报刊公告或电话通知等。该等变更自公告或通知中载明的生效日期起开始生效，本人有权在生效日期前选择是否同意该等变更。如本人不接受该等变更，本人将在公告或通知中载明的生效日期前停止使用</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人提供的服务，</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">否则视为本人同意该等变更，变更后的内容对本人具有法律约束力。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十五、上述个人信息原则上将存储于中华人民共和国境内（不包括香港、澳门特别行政区及台湾地区）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十六、</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">十七、如被授权人申请电子认证，本人同意并授权被授权人根据《电子认证服务管理办法》通过系统对接，将本人的个人信息（姓名、证件类型、证件号码）提供给电子认证服务提供者，进行电子认证，以保证本授权的有效性及其内容不被篡改。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人声明：</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人已年满【18】周岁。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人同意本授权书以数据电文形式成立，自本人在线确认起即生效。</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：【&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp; 】</span>
          </p>
          <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：【</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style="font-family:宋体; font-size:11pt; font-weight:bold">】</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
